<div class="container">
  <ul class="breadcrumb">
    <li><strong>Onde estou:</strong></li>
    <li class="active">
      <span id="lblSubMenu">Cadastros/Postos/<b>Ajuste Preço Combustível</b></span>
    </li>
  </ul>
  <div class="row info">
    <div class="col-sm-12 col-md-6 col-xl-6">
      <h2>PREÇO DO COMBUSTÍVEL:</h2>
      <p *ngIf="algumCombustivelDesatualizado" class="label-desatualizado"> *Os preços dos
        combustíveis destacados estão
        desatualizados
        há mais de 21 dias. Por favor, atualize-os.</p>
    </div>
    <div class="col-md-6 col-xl-6 text-end align-self-rigth">

      <ng-template [ngIf]="usuarioTemAcessoUploadCsv">
        <button routerLink="/upload-csv" title="Atualizar preço por planilha" type="button"
          class="btn btn-primary btn1">
          <img src="assets/icons/ir-para-upload-csv.svg" alt="upload">
          Atualizar preço
          por planilha
        </button>
      </ng-template>


      <button title="Baixar manual de instruções" type="button"
        (click)="baixarPdf('Manual - Nova tela de atualização de preços_Portal CTF.pdf')" class="btn btn-primary btn1">
        <img src="assets/icons/download-pdf.svg" alt="upload">
        Manual de instruções
      </button>
    </div>
  </div>
    <div class="select-posto mb-4 mb-0 pb-0" *ngIf="postosMacroPosto">

  <app-macro-posto-select
    [postosMacroPosto]="postosMacroPosto"
    (postoSelecionado)="handlePostoSelecionado($event)"

    ></app-macro-posto-select>
      </div>



  <div class="table">
    <div class="table-responsive">


      <div class="accordion" role="tablist" id="accordion-1" *ngIf="precosPosto.length > 0 || demaisPrecos.length > 0">
        <div class="accordion-item">
          <h2 class="accordion-header" role="tab">
            <button class="accordion-button" (click)="mostrarPrimeiraAba = !mostrarPrimeiraAba"
              [ngClass]="mostrarPrimeiraAba ? '': 'collapsed'" type="button" data-bs-toggle="collapse"
              data-bs-target="#accordion-1 .item-1" aria-expanded="true" aria-controls="accordion-1 .item-1">
              Com Preço Cadastrado </button>
          </h2>
          <div [ngClass]="mostrarPrimeiraAba ? 'show': ''" class="accordion-collapse collapse item-1" role="tabpanel"
            data-bs-parent="#accordion-1">
            <div class="accordion-body">
              <app-menu-combustiveis [comRedeEspecial]="ehRedeEspecial"></app-menu-combustiveis>

              <div class="row linha-combustivel" *ngFor="let item of precosPosto; track item?.codCombustivel">
                <div class="col" [ngClass]="item.possuiErros ? 'label-error': ''"
                  [ngClass]="item.desatualizado ? 'label-desatualizado': ''">
                  <p>
                    <img (click)="handleZerarPrecoCombustivel(item)" class="img-trash"
                      ngbTooltip="Remover preço do combustível" placement="top" src="assets/icons/trash.svg"
                      alt="remover das vendas">

                    {{item.descricaoCombustivel}}
                  </p>

                </div>
                <div class="col">
                  <input [ngClass]="item.possuiErros ? 'input-error': ''"
                    [ngClass]="item.desatualizado ? 'input-desatualizado': ''" type="text" currencyMask forceCursorEnd
                    (keyup)="verificarPrecos(item)" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    [(ngModel)]="item.precoBomba" />
                </div>
                <div class="col">
                  <input (keyup)="verificarPrecos(item)" [ngClass]="item.possuiErros ? 'input-error': ''"
                    [ngClass]="item.desatualizado ? 'input-desatualizado': ''" type="text" currencyMask forceCursorEnd
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" [(ngModel)]="item.descontoSps" />
                  <span>={{item.precoSps | currency: 'BRL'}}</span>

                </div>
                <div class="col" *ngIf="ehRedeEspecial">
                  <input (keyup)="verificarPrecos(item)" [ngClass]="item.possuiErros ? 'input-error': ''"
                    [ngClass]="item.desatualizado ? 'input-desatualizado': ''" type="text" currencyMask forceCursorEnd
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    [(ngModel)]="item.descontoRedeEspecial" />
                  <span>= {{item.precoRedeEspecial | currency: 'BRL'}}</span>
                </div>
                <div class="col" [ngClass]="item.possuiErros ? 'label-error': ''"
                  [ngClass]="item.desatualizado ? 'label-desatualizado': ''">
                  <p>
                    {{item.dataUltimaAtualizacao | date:
                    "dd/MM/yyyy"}}
                  </p>
                </div>

                <div class="col-12 erros-alerta" *ngIf="item.possuiErros">
                  <small>{{item.erros[0].msg}} </small>
                </div>

              </div>


            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" role="tab">
            <button class="accordion-button" (click)="mostrarPrimeiraAba = !mostrarPrimeiraAba"
              [ngClass]="!mostrarPrimeiraAba? '': 'collapsed'" type="button" data-bs-toggle="collapse"
              data-bs-target="#accordion-1 .item-2" aria-expanded="false" aria-controls="accordion-1 .item-2">Sem Preço
              Cadastrado</button>

          </h2>
          <div class="accordion-collapse collapse item-2" [ngClass]="!mostrarPrimeiraAba ? 'show': ''" role="tabpanel"
            data-bs-parent="#accordion-1">
            <div class="accordion-body">
              <app-menu-combustiveis [comRedeEspecial]="ehRedeEspecial"
                [precosComValores]=false></app-menu-combustiveis>
              <div class="row linha-combustivel" *ngFor="let item of demaisPrecos; track item?.codCombustivel">
                <div class="col" [ngClass]="item.possuiErros ? 'label-error': ''"
                  [ngClass]="item.desatualizado ? 'label-desatualizado': ''">
                  <p>{{item.descricaoCombustivel}}</p>
                </div>
                <div class="col">
                  <input [ngClass]="item.possuiErros ? 'input-error': ''"
                    [ngClass]="item.desatualizado ? 'input-desatualizado': ''" type="text" currencyMask forceCursorEnd
                    (keyup)="verificarPrecos(item)" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    [(ngModel)]="item.precoBomba" />
                </div>
                <div class="col">
                  <input (keyup)="verificarPrecos(item)" [ngClass]="item.possuiErros ? 'input-error': ''"
                    [ngClass]="item.desatualizado ? 'input-desatualizado': ''" type="text" currencyMask forceCursorEnd
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" [(ngModel)]="item.descontoSps" />
                  <span>={{item.precoSps | currency: 'BRL'}}</span>
                </div>
                <div class="col" *ngIf="ehRedeEspecial">
                  <input (keyup)="verificarPrecos(item)" [ngClass]="item.possuiErros ? 'input-error': ''"
                    [ngClass]="item.desatualizado ? 'input-desatualizado': ''" type="text" currencyMask forceCursorEnd
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                    [(ngModel)]="item.descontoRedeEspecial" />
                  <span>={{item.precoRedeEspecial | currency: 'BRL'}}</span>
                </div>
                <div class="col-12" *ngIf="item.possuiErros">
                  <small style="font-weight: bold;">{{item.erros[0].msg}} </small>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="col-12 text-center" *ngIf="precosPosto?.length == 0
      && demaisPrecos?.length == 0
      &&  loading == false" style="font-size: 32px;
      margin-top: 15%;
      ">
        {{msgInicialTabelaPrecos}}
      </div>

    </div>


  <div class="row" style="padding-left: 28px; margin-top: 12px;">
    <div class="col align-self-center">
      <p>*Ao clicar em <strong>Manter precos</strong>, todos os combustíveis com preço cadastrado terão a data
        atualizada para a data de hoje, mantendo o preço atual.</p>
    </div>
  </div>

  <div class="row">
    <div class="col-md-7 col-lg-6 offset-md-5 offset-lg-6 text-end align-self-end enviar-dados">
      <button (click)="confirmarPrecosModal = true" class="btn btn-selecionado btn2" type="button">Manter preços
      </button>
      <button [disabled]="existeErro() || !combustiveisModificados.length" (click)="mostrarModal = true"
        class="btn btn-primary btn2" style="margin-left: 30px;" type="button">Salvar
        alterações</button>
    </div>
  </div>
</div>
</div>

<div class="modal" id="carregando" tabindex="-1" [hidden]="!loading">
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-body corpo-spinner">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <h2>
          {{msgModalLoading}}
        </h2>
      </div>

    </div>
  </div>
</div>

<div class="modal" tabindex="-1" [hidden]="!mostrarModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <h3 *ngIf="postoSelecionado" >Você está atualizando os preços de: {{postoSelecionado.codPosto}}-{{postoSelecionado.nomePosto}}</h3>
        <h3 *ngIf="!postoSelecionado" >Você está atualizando os preços.</h3>
        <ul class="ps-0" *ngIf="combustiveisModificados.length">
          <li *ngFor="let comb of combustiveisModificados; track comb?.codCombustivel">
            {{comb?.descricaoCombustivel}}
          </li>
        </ul>
        <p style="padding-top: 16px; padding-bottom: 0; color:red"><strong>Atenção:</strong></p>
        <p style="color: red; padding-top: 0">Ao clicar em confirmar, você garante que os preços de todos os demais
          combustíveis também estão corretos. Assim, a data de atualização será registrada como a data de hoje.</p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-selecionado btn2" data-bs-dismiss="modal" (click)="mostrarModal = false">
          Cancelar
        </button>
        <button type="button" (click)="submeterPrecos()" class="btn btn-primary btn2">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" [hidden]="!confirmarPrecosModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <h3 *ngIf="!postoSelecionado" >Você está confirmando os preços de todos combustíveis</h3>
        <h3 *ngIf="postoSelecionado" >Você está confirmando os preços de todos combustíveis de: {{postoSelecionado.codPosto}}-{{postoSelecionado.nomePosto}}</h3>

        <p>Todas as datas de atualização de preço serão atualizadas para a data de hoje.</p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-selecionado btn2" data-bs-dismiss="modal"
          (click)="confirmarPrecosModal = false">
          Cancelar
        </button>
        <button type="button" (click)="manterPrecos()" class="btn btn-primary btn2">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" [hidden]="!comfirmaZerarCombustivel">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <h3 *ngIf="postoSelecionado" >Você confirma que está removendo de: {{postoSelecionado.codPosto}}-{{postoSelecionado.nomePosto}} o preço do combustível abaixo?</h3>
        <h3 *ngIf="!postoSelecionado" >Você confirma que está removendo o preço do combustível abaixo?</h3>
        <ul class="ps-0">
          <li *ngIf="precoSendoModificado">
            {{precoSendoModificado.descricaoCombustivel}}
          </li>
        </ul>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-selecionado btn2" data-bs-dismiss="modal"
          (click)="comfirmaZerarCombustivel = !comfirmaZerarCombustivel">
          Cancelar
        </button>
        <button type="button" (click)="zerarPrecoCombustivel()" class="btn btn-primary btn2">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" [hidden]="!comfirmaMudancaPosto">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body" *ngIf="postoSelecionado">
          <h3>Existem alterações de preços não salvas de: {{postoSelecionado.codPosto}}-{{postoSelecionado.nomePosto}} !</h3>
          <p>Ao trocar de posto elas serão perdidas, deseja continuar?</p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn btn-selecionado btn2" data-bs-dismiss="modal"
          (click)="cancelarTroca()">
          Cancelar
        </button>
        <button type="button" (click)="confirmarTroca()" class="btn btn-primary btn2">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>

